import { FieldErrors, UseFormRegister } from 'react-hook-form'

export interface TextInputProps {
  register: UseFormRegister<any>
  errors: FieldErrors<any>
  name: string
  label: string
  placeholder?: string
  sx?: any
  defaultValue?: string
  required?: boolean
}

export enum OrderByOptions {
  NAME_ASC = 'name_asc',
  NAME_DESC = 'name_desc',
  CREATED_AT_ASC = 'created_at_asc',
  CREATED_AT_DESC = 'created_at_desc'
}
